import React from 'react';
import { BoundSearchQuery } from "../../../types/common/BoundSearchQuery";
import { AdminBookingSearchCriteria, ADMIN_BOOKINGS_DATE_BYPASS_KEYS } from "../../../types/model/criteria/bookingSearchCriteria/AdminBookingSearchCriteria";
import { PageableParams } from "../../../types/model/params/PageableParams";
import { optionsEndpoints } from "../../../requests/api-endpoints";
import {
  AssetTypeGroups,
  BookingStatus,
  BookingDurationType
} from "../../constants/securspace-constants";
import {
  SortFilterContainer,
  SortFilterItemContainer,
  SortFilterRowContainer
} from "../../common/reports/sortFilter";
import {
  sortByFields,
  AdminBookingSortByType,
  AdminBookingSortParams
} from "../../../types/model/params/sortParams/AdminBookingSortParams";
import {
  BoundSortSelect,
  BoundDataDrivenAutocomplete,
  BoundDateRangeFilter,
  BoundSelect,
  BoundTextInput,
  BoundYesNoSelect
} from "../../common/inputs/boundInputs";

export interface AdminBookingSearchParams extends AdminBookingSearchCriteria, AdminBookingSortParams, PageableParams, BoundSearchQuery {}

export interface AdminBookingSortFilterProps {
  query: AdminBookingSearchParams;
  onChange: (newQuery: AdminBookingSearchParams) => void;
}

const AdminBookingSortFilter = ({
  query,
  onChange
}: AdminBookingSortFilterProps) => {

  return <SortFilterContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundTextInput<AdminBookingSearchParams>
          label="Booking Number"
          name="bookingNumber"
          value={query?.bookingNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <BoundDateRangeFilter<AdminBookingSearchParams>
        query={query}
        onChange={onChange}
        showEndDate={false}
        dateBypassKeys={ADMIN_BOOKINGS_DATE_BYPASS_KEYS}
        idSearchLabel="booking number"
      />
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<AdminBookingSearchParams>
          label="Buyer"
          requestUrl={optionsEndpoints.admin.account.buyer}
          name="buyerAccountId"
          value={query?.buyerAccountId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<AdminBookingSearchParams>
          label="Supplier"
          requestUrl={optionsEndpoints.admin.account.supplier}
          name="supplierAccountId"
          value={query?.supplierAccountId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<AdminBookingSearchParams>
          label="Location"
          requestUrl={optionsEndpoints.admin.location}
          name="locationId"
          value={query?.locationId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundSelect<AdminBookingSearchParams>
          options={BookingStatus}
          label="Status"
          name="status"
          value={query?.status}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundYesNoSelect<AdminBookingSearchParams>
          label="Brokered"
          name="brokered"
          value={query?.brokered}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundSortSelect<AdminBookingSearchParams, AdminBookingSortByType>
          query={query}
          defaultSortBy="CREATION_DATE"
          defaultSortDir="desc"
          sortByFields={sortByFields}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundSelect<AdminBookingSearchParams>
          options={AssetTypeGroups}
          label="Asset Type"
          name="assetTypeGroup"
          value={query?.assetTypeGroup}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundSelect<AdminBookingSearchParams>
          options={BookingDurationType}
          label="Frequency"
          name="durationType"
          value={query?.durationType}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer/>
    </SortFilterRowContainer>
  </SortFilterContainer>
}

export { AdminBookingSortFilter };
